export class ApplicationConfigFile {
  file?: File;
  name: string = "";
  comment: string = "";
  version: string | number = "";
}
